/**
 * Utility functions for prompt text sanitization and formatting
 */

/**
 * Sanitizes prompt text by removing sensitive information
 * @param {string} raw - Raw prompt text
 * @returns {string} Sanitized prompt text
 */
export function sanitizePromptText(raw) {
  if (!raw) return '';
  let text = String(raw);
  
  // Remove email addresses
  const emailPattern = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
  text = text.replace(emailPattern, '[contact]');
  
  // Remove admin-related sentences
  const adminSentencePattern = /(?:^|[.!?\n])[^.!?\n]*\badmin\b[^.!?\n]*(?=[.!?\n]|$)/gi;
  text = text.replace(adminSentencePattern, '.');
  
  // Clean up whitespace
  return text.replace(/[ \t]+/g, ' ').trim();
}

/**
 * Formats duration from milliseconds to MM:SS format
 * @param {number} ms - Duration in milliseconds
 * @returns {string|null} Formatted duration or null if invalid
 */
export function formatDurationMs(ms) {
  if (!Number.isFinite(Number(ms)) || Number(ms) <= 0) return null;
  const totalSeconds = Math.round(Number(ms) / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}

/**
 * Cleans and validates prompts from API response
 * @param {Array} prompts - Raw prompts array
 * @returns {Array} Cleaned prompts array
 */
export function cleanPrompts(prompts) {
  if (!Array.isArray(prompts)) return [];
  
  return prompts
    .filter(p => p && typeof p.text === 'string' && p.text.trim())
    .map(p => ({ 
      ...p, 
      text: sanitizePromptText(p.text) 
    }));
}
